// 4 位专家分析师角色定义（AI 思考与决策流使用）
// Backend agentType 固定为 fundamental | technical | sentiment | news

export type AgentType = 'fundamental' | 'technical' | 'sentiment' | 'news';

export interface AgentPersona {
  type: AgentType;
  label: string;
  focus: string;
  icon: string;
  emoji: string;
  traceStage: string;
}

export const AGENT_PERSONAS: Record<AgentType, AgentPersona> = {
  fundamental: {
    type: 'fundamental',
    label: '财报研究员',
    focus: '盈利能力 · 估值 · 财报 · 行业地位',
    icon: 'ri-file-chart-line',
    emoji: '💼',
    traceStage: 'analyst.fundamental',
  },
  technical: {
    type: 'technical',
    label: '量化交易员',
    focus: 'K 线 · 均线 · 量价 · MACD/RSI',
    icon: 'ri-line-chart-line',
    emoji: '📈',
    traceStage: 'analyst.technical',
  },
  sentiment: {
    type: 'sentiment',
    label: '资金分析师',
    focus: '北向资金 · 融资余额 · 主力资金 · 散户情绪',
    icon: 'ri-radar-line',
    emoji: '📡',
    traceStage: 'analyst.sentiment',
  },
  news: {
    type: 'news',
    label: '行业研究员',
    focus: '政策 · 公告 · 研报 · 产业链消息',
    icon: 'ri-newspaper-line',
    emoji: '📰',
    traceStage: 'analyst.news',
  },
};

export function agentLabel(type: string): string {
  return (AGENT_PERSONAS as Record<string, AgentPersona>)[type]?.label || type;
}

export function agentFocus(type: string): string {
  return (AGENT_PERSONAS as Record<string, AgentPersona>)[type]?.focus || '';
}

export function agentIcon(type: string): string {
  return (AGENT_PERSONAS as Record<string, AgentPersona>)[type]?.icon || 'ri-file-line';
}

export function agentEmoji(type: string): string {
  return (AGENT_PERSONAS as Record<string, AgentPersona>)[type]?.emoji || '🧠';
}

export function agentTypeFromStage(stage: string): AgentType | null {
  switch (stage) {
    case 'analyst.fundamental': return 'fundamental';
    case 'analyst.technical': return 'technical';
    case 'analyst.sentiment': return 'sentiment';
    case 'analyst.news': return 'news';
    default: return null;
  }
}

export const AGENT_ORDER: AgentType[] = ['fundamental', 'technical', 'sentiment', 'news'];
